import {ContactUserCard} from './contact-user-card';

export class UserInListDto extends ContactUserCard {
  id: number;
  listId: number;

  setContactUserCard(contactUserCard: ContactUserCard) {
    this.userId = contactUserCard.userId;
    this.sourceId = contactUserCard.sourceId;
    this.customerId = contactUserCard.customerId;
    this.userFirstName = contactUserCard.userFirstName;
    this.userLastName = contactUserCard.userLastName;
    this.userEmail = contactUserCard.userEmail;
    this.dialogCount = contactUserCard.dialogCount;
    this.userMiddleName = contactUserCard.userMiddleName;
    this.userZip = contactUserCard.userZip;
    this.userState = contactUserCard.userState;
    this.userCity = contactUserCard.userCity;
    this.userAddress = contactUserCard.userAddress;
    this.userGender = contactUserCard.userGender;
    this.userDob = contactUserCard.userDob;
    this.userPhone = contactUserCard.userPhone;
    this.userMetadata = contactUserCard.userMetadata;
    this.userAllowSms = contactUserCard.userAllowSms;
  }
}
